import React from 'react'
import "./NewPreviewUI.css"
import { Skeleton, Stack } from '@mui/material'
const NewPreviewLeftSkeleton = () => {
      return (
            <div className='newPreviewLeftCustomisationList'>
                  <div className='newPreviewLeftCustomisationSkeletonContainer'>
                        <Stack spacing={1}>
                              <Skeleton variant="text" width="80%" height="5vh" sx={{ fontSize: '1rem', bgcolor: 'grey.500' }} />
                              <Skeleton variant="text" sx={{ fontSize: '1rem', bgcolor: 'grey.500' }} />

                              <div className='newPreviewLeftCustomisationSkeletonCardContainer'>
                                    <Skeleton variant="rounded" width="100%" height="15vh" sx={{ bgcolor: 'grey.500' }} />
                                    <Skeleton variant="rounded" width="100%" height="15vh" sx={{ bgcolor: 'grey.500' }} />
                                    <Skeleton variant="rounded" width="100%" height="15vh" sx={{ bgcolor: 'grey.500' }} />

                              </div>
                        </Stack>
                  </div>
            </div>
      )
}

export default NewPreviewLeftSkeleton